import { useEffect, useState } from 'react';

import { useFeatureDiscovery } from '@confluence/feature-discovery';

import { usePremiumFeatureUsage } from './usePremiumFeatureUsage.ts';

const MID_TRIAL_PREMIUM_ONBOARDING_MODAL = 'mid-trial-premium-onboarding-modal';

type useShowMidTrialPremiumOnboardingProps = {
	isPremiumOnboardingFeatureDiscoveryEnabled: boolean;
	isSiteAdmin: boolean;
	isTrialHalfWayThrough: boolean;
};

export const useShowMidTrialPremiumOnboardingModal = ({
	isPremiumOnboardingFeatureDiscoveryEnabled,
	isSiteAdmin,
	isTrialHalfWayThrough,
}: useShowMidTrialPremiumOnboardingProps) => {
	const isEligibleToShowMidTrialModal =
		isPremiumOnboardingFeatureDiscoveryEnabled && isTrialHalfWayThrough;

	const { totalFeaturesUsed } = usePremiumFeatureUsage({
		skip: !isEligibleToShowMidTrialModal || isSiteAdmin,
	});

	/**
	 * Productionization note:
	 * Remove this block
	 * return shouldShowMidTrialPremiumOnboardingModal: totalFeaturesUsed > 0
	 */
	const [shouldShowModal, stopModal] = useFeatureDiscovery(
		MID_TRIAL_PREMIUM_ONBOARDING_MODAL,
		/*skip */ totalFeaturesUsed == 0,
	);

	const [shouldShowMidTrialPremiumOnboardingModal, setShouldShowMidTrialPremiumOnboardingModal] =
		useState<boolean>(false);

	// prevent state update when shouldShowModal becoming false due to stopModal is called
	useEffect(() => {
		if (shouldShowModal) {
			setShouldShowMidTrialPremiumOnboardingModal(true);
		}
	}, [shouldShowModal]);

	return {
		shouldShowMidTrialPremiumOnboardingModal,
		stopMidTrialPremiumOnboardingModal: stopModal,
	};
};
